import React, { Suspense } from 'react';
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createBrowserHistory } from 'history'
import { BrowserRouter as Router } from "react-router-dom";
import loadable from "./components/Lazy";
import * as serviceWorker from './serviceWorker';
import rootSaga from './sagas';
import configureStore from './store';
import { ThemeProvider } from "@material-ui/core/styles";

import theme from './theme';
import PickOutline from "./components/Pick/PickOutline";
import ApiOpportunityPage from "./components/ApiOpportunityPage";
import PressAndMediaPage from "./components/PressAndMediaPage";
import Error404 from "./components/Error404";
import ViewGiftButton from './components/ViewGiftButton/ViewGiftButton';
import CustomizeGift from "./components/CustomizeGift";
import AccountSocialConnections from "./components/Account/AccountSocialConnections";
import SecureCheckoutPaymentRoute from "./Routes/SecureCheckout/SecureCheckoutPaymentRoute";
import LoginResendButton from "./components/Login/LoginResendButton";


const PickCard = loadable(() => import('./components/PickCard/PickCard'));
const App = loadable(() => import('./App'));
const Pick = loadable(() => import('./components/Pick/pick'));
const CreateProfileFull = loadable(() => import('./components/CreateProfileFull/CreateProfileFull'));
const DownloadAppPage = loadable(() => import('./components/DownloadAppPage'));
const AccountSidebar = loadable(() => import('./components/AccountSidebar/AccountSidebar'));
const AccountFavorites = loadable(() => import('./components/AccountFavorites/AccountFavorites'));
const LinkRedemptionAccountForm = loadable(() => import('./components/LinkRedemptionAccountForm/LinkRedemptionAccountForm'));
const LoadingSpinner = loadable(() => import('./components/LoadingSpinner/LoadingSpinner'));
const HeaderInTwig = loadable(() => import('./components/App/HeaderInTwig'));
const FooterInTwig = loadable(() => import('./components/App/FooterInTwig'));
const GiftCard = loadable(() => import('./components/Gift/GiftCardNew'));
const Search = loadable(() => import('./components/Search/Search'));

const initialState = {};
const history = createBrowserHistory();
const store = configureStore(initialState, history);

store.runSaga(rootSaga);

const rootEle = document.getElementById('react-root');
if (rootEle) {
    ReactDOM.render(
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <Suspense fallback={<div />}>
                    <App/>
                </Suspense>
            </ThemeProvider>
        </Provider>,
        rootEle
    );
}


let containers;


containers = document.querySelectorAll('[data-react-pick]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <Pick {...props}  />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}



containers = document.querySelectorAll('[data-react-secure-checkout-payment-route]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];

        const props = {
            ...container.dataset,
            savedPaymentMethods: JSON.parse(container.dataset.savedPaymentMethods)
        }


        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <SecureCheckoutPaymentRoute {...props}  />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}


containers = document.querySelectorAll('[data-react-404-default]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <Error404 {...props}  />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-account-social-connections]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <AccountSocialConnections {...props}  />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-login-resend-button]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <LoginResendButton {...props}  />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-account-sidebar]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <AccountSidebar {...props}  />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}


const renderGiftCard = () => {
    containers = document.querySelectorAll('[data-react-gift-card]');
    for (let i in containers) {
        if (containers.hasOwnProperty(i)) {
            let container = containers[i];
            const dataset = container.dataset;

            const props = {
                image: dataset.image,
                wrappingImage: dataset.wrappingImage,
                title: dataset.title,
                video: dataset.video,
                autoopen: dataset.autoopen === 'true',
                fontsize: dataset.fontsize,
                hover: dataset.hover === 'true',
                limited: dataset.limited === 'true',
                reactGiftCard: dataset.reactGiftCard,
                tease: dataset.tease === 'true',
                viewerIsRecipient: dataset.viewerIsRecipient === 'true',
                gift: {
                    range: dataset.range,
                    merchantMainCategoryName: dataset.merchantMainCategoryName,
                    viewerIsRecipient: dataset.viewerIsRecipient,
                    merchantName: dataset.merchantName,
                    image: dataset.image

                }
            };

            ReactDOM.render(
                <Provider store={store}>
                    <ThemeProvider theme={theme}>
                        <Suspense fallback={<div />}>
                            <GiftCard {...props}  />
                        </Suspense>
                    </ThemeProvider>
                </Provider>,
                container
            );
        }
    }
};
window.renderGiftCard = renderGiftCard;
renderGiftCard();

containers = document.querySelectorAll('[data-react-account-favorites]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <AccountFavorites {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-search]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = {
            ...container.dataset,
            includePlaceInPath: container.dataset.includePlaceInPath === 'true',
            pickLimited: container.dataset.pickLimited === 'true',
            nearMe: container.dataset.nearMe !== 'false',
            syncUrl: container.dataset.syncUrl === '' ? null : container.dataset.syncUrl,
            onMerchantSelect: container.dataset.onMerchantSelect === 'giftya_select' ? 'giftya_select' : null
        };

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <Search {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-loading-spinner]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <LoadingSpinner {...container.dataset} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-customize-gift]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = {
            ...container.dataset,
            cartCount: container.dataset.cartCount - 0,
        };

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <CustomizeGift {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-pick-outline]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = {
            rootStyles: {
                height: container.dataset.rootStylesHeight,
                width: container.dataset.rootStylesWidth,
                position: container.dataset.rootStylesPosition,
                top: container.dataset.rootStylesTop,
                left: container.dataset.rootStylesLeft,
            }
        };

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <PickOutline {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-header]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];

        const props = {
            elementsMobileLeftComponent: container.dataset.elementsMobileLeftComponent,
            elementsMobileMiddleComponent: container.dataset.elementsMobileMiddleComponent,
            elementsMobileRightComponent: container.dataset.elementsMobileRightComponent === 'empty' ? false : container.dataset.elementsMobileRightComponent,
            elementsDesktopLeftComponent: 'logo',
            elementsDesktopMiddleComponent: 'menu',
            elementsDesktopRightComponent: 'account',
            ...container.dataset, 
            includePromoBanner: container.dataset.includePromoBanner === 'false' ? false : true,
            includeSecondaryBar: container.dataset.includeSecondaryBar === 'true' ? true : false,
            includeSearchBar: container.dataset.includeSearchBar === 'true' ? true : false,
            includeBreadCrumbs: container.dataset.includeBreadCrumbs === 'true' ? true : false,
            includeBackBtn: container.dataset.includeBackBtn === 'true' ? true : false,
            backHistory: container.dataset.backHistory === 'true' ? true : false,
            backBtnText: container.dataset.backBtnText,
            backUrl: container.dataset.backUrl,
            secondBreadCrumb: container.dataset.secondBreadCrumb === 'false' ? false : '...', 
            thirdBreadCrumb: container.dataset.thirdBreadCrumb,
            headerTitle: container.dataset.headerTitle
        };

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                    <Router>
                        <HeaderInTwig
                            elements={{
                                mobile: {
                                    leftComponent: props.elementsMobileLeftComponent,
                                    middleComponent: props.elementsMobileMiddleComponent,
                                    rightComponent: props.elementsMobileRightComponent,
                                },
                                desktop: {
                                    leftComponent: props.elementsDesktopLeftComponent,
                                    middleComponent: props.elementsDesktopMiddleComponent,
                                    rightComponent: props.elementsDesktopRightComponent,
                                }
                            }}
                            {...props} fullReact={false}/>
                    </Router>
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-footer]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <Suspense fallback={<div />}>
                            <FooterInTwig {...props}/>
                        </Suspense>
                    </Router>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-pick-card]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <PickCard {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-view-gift-button]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <ViewGiftButton {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-loading-spinner]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <LoadingSpinner {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-link-redemption-account-form]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <LinkRedemptionAccountForm {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-create-profile-full]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <CreateProfileFull {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-download-app-page]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <DownloadAppPage {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}

containers = document.querySelectorAll('[data-react-api-opportunity-page]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<div />}>
                        <ApiOpportunityPage {...props} />
                    </Suspense>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}
containers = document.querySelectorAll('[data-react-press-and-media-page]');
for (let i in containers) {
    if (containers.hasOwnProperty(i)) {
        let container = containers[i];
        const props = container.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <Suspense fallback={<div />}>
                            <PressAndMediaPage {...props} />
                        </Suspense>
                    </Router>
                </ThemeProvider>
            </Provider>,
            container
        );
    }
}



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();